import React, { useContext } from 'react';
import { Col, Image } from '@thd-olt-component-react/core-ui';
import { PackagesMiniContext } from '../PackagesMiniContext';
import {
  getPackageTitle,
  getImageUrl,
  getBrandImage,
  getBrandName,
  getPackageUrl
} from '../../utils';
import { VisualProductImages } from './VisualProductImages';
import './visual-package-info.scss';

const VisualPackageInfo = () => {
  const { packageModel, products } = useContext(PackagesMiniContext);
  const packageImageUrl = getImageUrl(packageModel);
  const packageTitle = getPackageTitle(packageModel);
  // TODO: Brand images are null or package image for GM packages
  const packageBrandImage = getBrandImage(packageModel);
  const packageBrandName = getBrandName(packageModel);
  const packageUrl = getPackageUrl(packageModel);

  return (
    <>
      {
        !['', packageImageUrl].includes(packageBrandImage) && (
          <Col flatten>
            <Image
              src={packageBrandImage}
              alt={`${packageBrandName} logo`}
              width="90"
            />
          </Col>
        )
      }
      <Col className="visual-package-info__title-container">
        <h2 className="visual-package-info__title">
          {packageTitle}
        </h2>
        {products.length && (
          <a href={packageUrl}>
            {`(${products.length} Items)`}
          </a>
        )}
      </Col>
      <Col className="visual-package-info__mobile-images-container" flatten>
        <VisualProductImages />
      </Col>
    </>
  );
};

VisualPackageInfo.displayName = 'VisualPackageInfo';

export { VisualPackageInfo };